import { useLocation, useNavigate } from '@hulu/react-router-dom';
import { PropsWithChildren, useContext, useEffect } from 'react';

import { RoutePath } from '../../constants';
import { GhostModeContext } from '../../context/GhostMode/GhostMode';
import { User } from '../../utils/user';

type Props = PropsWithChildren<{
  permitted: boolean;
  prefix?: string;
}>;

const PermittedPage = ({ children, permitted, prefix = '' }: Props): JSX.Element | null => {
  const navigate = useNavigate();
  const location = useLocation();
  const deep = location.pathname.match(/\//g)?.length || 0;
  const { isGhostMode } = useContext(GhostModeContext);

  // Our admin page depends only on location path and related route

  const { pathname } = useLocation();

  const isAdminPortalOpened = pathname.slice(0, 6) === RoutePath.ADMIN;

  useEffect(() => {
    if (isGhostMode && User.getUserInfo().idToken && isAdminPortalOpened) {
      window.open(`${window.location.origin}${RoutePath.ACCOUNT}/profile`, '_self');
    }
  }, [isAdminPortalOpened, isGhostMode]);

  useEffect(() => {
    if (!permitted && !isGhostMode) {
      navigate(`${'../'.repeat(deep)}${prefix}${RoutePath.FORBIDDEN}`);
    }
  }, [deep, isGhostMode, navigate, permitted, prefix]);

  if (!permitted && !isGhostMode) {
    return null;
  }

  return <>{children}</>;
};

export default PermittedPage;
